import htmlParser from 'html-react-parser';

const getMessages = (cover, product, type, productConfig, conditionsApply, messages, messageParams, translator) => {
    const result = [];
    const categories = productConfig[type];

    categories.forEach((category) => {
        const translatedKeys = [];
        if (!category.titleOnly) {
            category.items.forEach((item) => {
                if (conditionsApply(cover, item)) {
                    const text = translator(messages[item.key], messageParams);
                    if (!translatedKeys.includes(htmlParser(text))) {
                        translatedKeys.push(htmlParser(text));
                    }
                }
            });
        }
        result.push({
            title: category.title && translator(messages[category.title]),
            titleOnly: category.titleOnly,
            id: category.title ? category.title : '',
            keys: translatedKeys
        });
    });
    return result;
};

const createListFromMessages = (messageArray, params, messages, translator) => {
    const filterMessages = Object.fromEntries(messageArray.map((x) => [x, messages[x]]));
    const newArray = Object.values(filterMessages);
    const data = [];
    newArray.forEach((item) => {
        data.push(translator(item, params));
    });
    return data;
};

export default {
    getMessages,
    createListFromMessages
};
